import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_3 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_4 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_5 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_6 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_7 = { class: "col-xxl-3 col-md-6 position-relative" }
const _hoisted_8 = { class: "col-xxl-3 col-md-6 position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultCard = _resolveComponent("DefaultCard")!
  const _component_CardWithImage = _resolveComponent("CardWithImage")!
  const _component_CardWithBgImage = _resolveComponent("CardWithBgImage")!
  const _component_CardWithList = _resolveComponent("CardWithList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DefaultCard)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DefaultCard)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DefaultCard)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DefaultCard)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_CardWithImage)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_CardWithBgImage)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_CardWithList)
    ])
  ]))
}